import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from './../index';
import _ from "lodash";
import moment from "moment";
// import { Container, Row, Col } from "reactstrap";
import { Button, Modal, Select, Form, Input, Row, Col, Radio, message } from "antd";
import Service from "./../../../extra/getAPI";
import Goi1 from "./../../../../src/assets/pvi-benhhiemngheo/goi1.png";
import Goi2 from "./../../../../src/assets/pvi-benhhiemngheo/goi2.png";
import Goi3 from "./../../../../src/assets/pvi-benhhiemngheo/goi3.png";
import Goi4 from "./../../../../src/assets/pvi-benhhiemngheo/goi4.png";
import Ithoigian from "./../../../../src/assets/pvi-benhhiemngheo/ithoigian.svg";
import IThoihan from "./../../../../src/assets/pvi-benhhiemngheo/ithoihan.svg";
import IQuyenloi from "./../../../../src/assets/pvi-benhhiemngheo/iquyenloi.svg";
import ICheck from "./../../../../src/assets/pvi-benhhiemngheo/icheck.png";
import Ihoten from "./../../../../src/assets/pvi-benhhiemngheo/ihoten.svg";
import Helper from "./../../../extra/helper";
import DatePicker from "../modalnotification/DatePicker";

const Package = () => {
  const { goStep, setPackagedID, Back, toltalFees, getTotalFees } = useContext(AuthContext);
  const { Option } = Select;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [datePicker, setDatePicker] = useState({});
  const [formData, setFormData] = useState({});
  const [listPackageInsu, setListPackageInsu] = useState([]);
  const [packageInsu, setPackageInsu] = useState({});
  const [listInsured, setListInsured] = useState([]);
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const img = [Goi1, Goi2, Goi3, Goi4];
  const earlyStage = [37500000, 75000000, 150000000, 300000000];
  const lateStage = [150000000, 300000000, 600000000, 1200000000];
  const charges = [250000, 500000, 1000000, 2000000];
  const compensation = [6250000, 12500000, 25000000, 50000000];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("dataIsu"));
    form.setFieldsValue(data || {});
    setFormData(data || {});
    window.scrollTo(0, 0);
  }, [localStorage.getItem('listInsured')]);

  useEffect(() => {
    if (formData?.insuredDob && formData?.insuredGender && formData.yearsOfInsurance) {
      getPackageInsu();
    }
  }, [formData.insuredDob, formData.insuredGender, formData.yearsOfInsurance]);

  const getPackageInsu = async () => {
    setLoading(true);
    const param = {
      insuredDob: moment(formData?.insuredDob, "DD/MM/YYYY").format("YYYY-MM-DD"),
      insuredGender: +formData.insuredGender,
      yearsOfInsurance: formData.yearsOfInsurance,
    };
    Service.apicall(
      "GET",
      `/v1/products/critical-disease/packages`, param
    )
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setLoading(false);
          setListPackageInsu(res.data.data);
        }
      })
      .catch((err) => {
        setListPackageInsu([]);
        // form.resetFields();
        // localStorage.removeItem('listInsured');
        setLoading(false);
        if (err.response) {
          message.error(err?.response?.data?.error?.statusCode + ' | ' + 'Không có chương trình phù hợp. Vui lòng chọn lại!');
        }
      });
  };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // const arr = Object.values(formData.listPackageInsu).map(i);

  const css = {
    input: {
      color: "#3A3A3A",
      zIndex: 1,
      fontSize: 15,
      boxShadow: "none",
      padding: "6px 35px",
      borderRadius: 9,
      width: "100%",
    },
    titleInput: { color: "#646D69", marginBottom: 3 },
    FormItemsHolder: {
      width: "100%",
      borderRadius: 8,
      margin: "5px 0px",
      padding: 0,
    },
    iconInput: {
      width: 20,
      margin: "12px 10px",
      position: "absolute",
      zIndex: 2,
    },
    btn: {
      color: "#009B4B",
      background: "#FFF",
      fontWeight: "bold",
      width: "100%",
      height: "44px",
      borderRadius: 8,
      border: "1px solid #009B4B",
    },
  };

  return (
    <div
      style={{
        fontSize: 14,
        background: "linear-gradient(180deg, #3040AD 0%, #3759D3 100%)",
      }}
    >
      <div>
        <Modal
          className="custom-modal-antd"
          style={{
            maxWidth: "100%",
            margin: 0,
            verticalAlign: "bottom",
            padding: 0,
            maxHeight: "90%",
          }}
          centered={true}
          footer={false}
          closable={true}
          open={isModalVisible}
          onCancel={handleCancel}
          maskStyle={{ background: '#000000', opacity: 0.8 }}
        >
          <div>
            <div
              style={{
                padding: "0px 10px 50px 10px",
                maxHeight: "85vh",
                overflowY: "scroll",
              }}
            >
              <div
                style={{
                  display: "flex",
                  paddingBottom: "20px",
                  top: 0,
                  alignItems: "flex-end",
                  position: 'sticky',
                  background: '#ffffff',
                  // height: '108px',
                }}
              >
                <div style={{ marginRight: 10 }}>
                  <img
                    style={{ width: 100 }}
                    src={img[packageInsu.packedIndex]}
                    alt="hinh gói 1"
                  />
                </div>
                <div>
                  <div style={{ color: "#2A3790" }}>
                    <div style={{ fontWeight: 500, fontSize: 18 }}>
                      {packageInsu.title || ""}
                    </div>
                    <div style={{ fontSize: 12 }}>
                      {packageInsu.benefit}
                    </div>
                  </div>
                  <div style={{ fontWeight: 500, fontSize: 20, marginTop: 2 }}>
                    <span>{packageInsu.fees}</span>
                    <span style={{ color: "#9A9A9A", fontSize: 18 }}> VNĐ</span>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 0px",
                  marginBottom: 10,
                  borderBottom: "1px solid #D9D9D9",
                  // marginTop: ' 100px'
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ width: 20, marginRight: 5 }}
                    src={IThoihan}
                    alt="quyen loi"
                  />
                  <span>Thời hạn bảo hiểm</span>
                </div>
                <div style={{ color: "#2A3790", fontWeight: 500 }}>{formData.yearsOfInsurance} năm</div>
              </div>
              <div
                style={{
                  padding: "0px 0px 10px 0px",
                  marginBottom: 10,
                  borderBottom: "1px solid #D9D9D9",
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ width: 20, marginRight: 5 }}
                    src={IQuyenloi}
                    alt="quyen loi"
                  />
                  <span>Quyền lợi bảo hiểm</span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    style={{ width: 20, marginRight: 5 }}
                    src={ICheck}
                    alt="quyen loi"
                  />
                  <div>
                    <div style={{ marginBottom: 5 }}>
                      Bệnh Ung thư, Đau tim, Đột quỵ
                    </div>
                    <div style={{ fontSize: 12 }}>
                      Giai đoạn sớm:{" "}
                      {Helper._formatMoney(earlyStage[packageInsu.packedIndex])} VNĐ
                    </div>
                    <div style={{ fontSize: 12 }}>
                      Giai đoạn trễ:{" "}
                      {Helper._formatMoney(lateStage[packageInsu.packedIndex])} VNĐ
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    style={{ width: 20, marginRight: 5 }}
                    src={ICheck}
                    alt="quyen loi"
                  />
                  <div>
                    <div style={{ marginBottom: 5 }}>Trợ cấp nằm viện</div>
                    <div style={{ fontSize: 12, marginBottom: 5 }}>
                      Bệnh Ung thư, Đau tim, Đột quỵ giai đoạn sớm
                      <br />
                      <i style={{ fontWeight: 300 }}>
                        (Trong vòng 180 ngày kể từ ngày Người được bảo hiểm có
                        chẩn đoán Ung thư, Đau tim, Đột quỵ giai đoạn sớm)
                      </i>
                      <br />
                      Mức phí: {Helper._formatMoney(charges[packageInsu.packedIndex])}{" "}
                      VNĐ/ngày, tối đa 45 ngày
                    </div>
                    <div style={{ fontSize: 12 }}>
                      Bệnh Ung thư, Đau tim, Đột quỵ giai đoạn trễ
                      <br />
                      <i style={{ fontWeight: 300 }}>
                        (Trong vòng 365 ngày kể từ ngày Người được bảo hiểm có
                        chẩn đoán Ung thư, Đau tim, Đột quỵ giai đoạn sớm)
                      </i>
                      <br />
                      Mức phí: {Helper._formatMoney(
                        charges[packageInsu.packedIndex]
                      )}{" "}
                      VNĐ/ngày, tối đa 90 ngày
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    style={{ width: 20, marginRight: 5 }}
                    src={ICheck}
                    alt="quyen loi"
                  />
                  <div>
                    <div style={{ marginBottom: 5 }}>
                      Tử vong do Bệnh Ung thư, Đau tim, Đột quỵ
                    </div>
                    <div style={{ fontSize: 12 }}>
                      Phí bồi thường{" "}
                      {Helper._formatMoney(compensation[packageInsu.packedIndex])} VNĐ/hợp
                      đồng
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 5,
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    style={{ width: 20, marginRight: 5 }}
                    src={ICheck}
                    alt="quyen loi"
                  />
                  <div>
                    <div style={{ marginBottom: 5 }}>Tử vong do Tai nạn</div>
                    <div style={{ fontSize: 12 }}>
                      Phí bồi thường {Helper._formatMoney(compensation[packageInsu.packedIndex])} VNĐ/hợp đồng
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                borderRadius: "16px 16px 0px 0px",
                justifyContent: "center",
                padding: "16px 18px 20px 18px",
                boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.1)",
                position: 'sticky',
                bottom: 0,
                width: "100%",
                background: "#ffffff",
                left: 0,
                right: 0,
                // height: '90px'
              }}
            >
              {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 10,
                }}
              >
                <div>Tổng tiền thanh toán</div>
                <div>
                  <span style={{ fontWeight: 600, color: '#2A3790', fontSize: 18 }}>
                    {toltalFees}
                  </span>
                  <span style={{ color: "#9A9A9A", fontSize: 14 }}> VNĐ</span>
                </div>
              </div> */}
              <Button
                onClick={() => goStep(3)}
                size="large"
                style={{
                  fontSize: 14,
                  background: "#2A3790",
                  color: "#ffffff",
                  width: "100%",
                  textAlign: "center",
                  borderRadius: 8,
                  fontWeight: 700,
                  height: 45,
                }}
              >
                Tiếp tục
              </Button>
            </div>
          </div>
        </Modal>
        <Form
          form={form}
          ref={formRef}
          onFinish={() => { }}
        // name="Serach_account"
        >
          <Row>
            <Col xs="12">
              <div
                style={{
                  color: "#ffffff",
                  fontSize: 16,
                  padding: "20px 10px 60px 10px",
                }}
              >
                <div>
                  <b>BẢO HIỂM BỆNH HIỂM NGHÈO</b>
                </div>
                <div style={{ fontSize: 11 }}>
                  Vui lòng chọn năm sinh và giới tính để xem<br /> chương trình bảo hiểm
                </div>
              </div>
            </Col>
            <Col
              xs="12"
              style={{
                borderRadius: "16px 16px 0px 0px",
                background: "#F9F9F9",
                zIndex: 2,
                width: '100%',
                height: '90vh',
                minHeight: 820,
                paddingBottom: 60
              }}
            >
              <div
                style={{
                  height: "165px",
                  color: "#646D69",
                  padding: "15px 20px",
                  borderRadius: "16px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  margin: "-40px 10px 0px 10px",
                  background: "#ffffff",
                  zIndex: 4
                }}
              >
                <div style={{ display: 'flex', alignItems: "center" }}>
                  <div style={{ width: "50%", marginRight: 5 }}>
                    <div
                      style={{ padding: "2% 3% 0px 3%", position: "relative" }}
                    >
                      <div style={css.titleInput}>Ngày sinh <sup style={{ color: 'red' }}>*</sup></div>
                      <img
                        style={css.iconInput}
                        src={Ithoigian}
                        alt="quyen loi"
                      />
                      <Form.Item
                        name="insuredDob"
                        rules={[
                          {
                            required: true,
                            message: "Vui lòng chọn và nhập thông tin",
                          },
                        ]}
                        style={css.FormItemsHolder}
                      >
                        <Input
                          autoComplete="off"
                          readOnly
                          style={{ ...css.input, paddingRight: "6px" }}
                          placeholder="DD/MM/YYYY"
                          onClick={() => {
                            setDatePicker({ ...datePicker, open: true });
                          }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div style={{ width: "50%", marginLeft: 5 }}>
                    <div style={{ padding: "0px", position: "relative" }}>
                      <div style={css.titleInput}>Giới tính <sup style={{ color: 'red' }}>*</sup></div>
                      <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
                      <Form.Item
                        name="insuredGender"
                        rules={[
                          {
                            required: true,
                            message: "Vui lòng chọn và nhập thông tin",
                          },
                        ]}
                        style={css.FormItemsHolder}
                      >
                        <Select
                          className="custom-select-antd"
                          autoComplete="off"
                          onChange={(e) => {
                            onChangForm({ data: e, name: "insuredGender" });
                          }}
                          placeholder="Chọn giới tính"
                        >
                          <Option value={1}>Nam</Option>
                          <Option value={2}>Nữ</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 10 }}>
                  <div>Số năm bảo hiểm<sup style={{ color: 'red' }}>*</sup></div>
                  <Form.Item
                    name="yearsOfInsurance"
                    rules={[{
                      required: true,
                      message: 'Vui lòng chọn và nhập thông tin'
                    }]}
                    style={css.FormItemsHolder}
                  >
                    <Radio.Group
                      onChange={(e) => {
                        onChangForm({ data: e.target.value, name: "yearsOfInsurance" });
                      }}
                      style={{ width: '100%' }}>
                      <Row>
                        <Col xs={8}  >
                          <Radio value={1}>1 năm</Radio>
                        </Col>
                        <Col xs={8} >
                          <Radio value={5}>5 năm</Radio>
                        </Col>
                        <Col xs={8}>
                          <Radio value={10}>10 năm</Radio>
                        </Col>
                      </Row>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>
              <div style={{ margin: "10px 0px", padding: '0px 10px', display: listPackageInsu?.length > 0 ? '' : 'none' }}>
                <span style={{ fontWeight: 500 }}>Chọn chương trình bảo hiểm</span>
                <br />
                <span style={{ fontSize: 12, color: "#9A9A9A" }}>
                  Phí bảo hiểm tuỳ theo độ tuổi và giới tính
                </span>
              </div>
              {(listPackageInsu || []).map((data, i) => (
                <div
                  onClick={() => {
                    if (loading) return
                    setPackagedID(i)
                    setIsModalVisible(true);
                    setPackageInsu({ ...data, packedIndex: i });
                    localStorage.setItem(
                      "dataIsu",
                      JSON.stringify({
                        ...formData,
                        package: data?.id,
                        listPackageInsu: listPackageInsu,
                        fee: data.value,
                        packedIndex: i
                      })
                    );
                    getTotalFees(data?.id);
                  }}
                  key={i}
                  style={{
                    display: "flex",
                    padding: "13px 16px",
                    background: "#ffffff",
                    borderRadius: 8,
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    margin: "0px 10px 20px 10px",
                    // margin:'0px 10px'
                  }}
                >
                  <div style={{ marginRight: 15 }}>
                    <img
                      style={{ width: 90 }}
                      src={img[i]}
                      alt={`hinh gói ${i + 1}`}
                    />
                  </div>
                  <div>
                    <div style={{ color: "#2A3790" }}>
                      <span style={{ fontWeight: 500 }}>{data.title}</span>
                      <br />
                      <span style={{ fontWeight: 500 }}>
                        {data.benefit}
                      </span>
                      <br />
                      <span style={{ color: "#9A9A9A" }}>{data.yearsOfInsurance}</span>
                    </div>
                    <div>
                      <span
                        style={{ fontWeight: 500, fontSize: 16, marginTop: 5 }}
                      >
                        {data.fees}
                      </span>
                      <span style={{ color: "#9A9A9A" }}> VNĐ</span>
                    </div>
                  </div>
                </div>
              ))}
            </Col>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                position: "fixed",
                width: "100%",
                maxWidth: 800,
                bottom: 0,
                height: 86,
                background: "#fff",
                borderRadius: "16px 16px 0px 0px",
                alignItems: "center",
                boxShadow: "0px -4px 8px 0px #0000001A",
                padding: "0px 10px",
                zIndex: 3
              }}
            >
              <Button
                loading={loading}
                onClick={() => Back()}
                style={{ ...css.btn, color: "#2A3790", background: "#FFF", marginBottom: 10, border: '1px solid #DDD' }}
                type="#2A3790"
              >
                Quay lại
              </Button>
            </div>
          </Row>
          {datePicker.open && (
            <DatePicker
              onConfirm={(data) => {
                onChangForm({ data, name: "insuredDob" });
                form.setFieldsValue({ "insuredDob": data })
              }}
              max={moment().add(1, 'd').subtract(15, "y").toDate()}
              min={moment().add(2, 'd').subtract(55, "y").toDate()}
              visible={datePicker.open}
              close={() => {
                setDatePicker({ ...datePicker, open: false });
              }}
              value={
                formData.insuredDob ||
                moment().subtract(15, "d").format("DD/MM//YYYY")
              }
            />
          )}
        </Form>
      </div>
    </div>
  );
};

export default Package;
